import { TAGS } from "../constants";
import { Pharmacy, PharmacyState, UpdatePharmacy } from "../types";
import { api } from "./api";

export const pharmacyApi = api.injectEndpoints({
  endpoints: (builder) => ({
    getPharmacies: builder.query<Pharmacy[], void>({
      query: () => ({
        method: "GET",
        url: `/api/pharmacies`,
      }),
      providesTags: [TAGS.PHARMACIES],
    }),

    getPharmacyStates: builder.query<PharmacyState[], number>({
      query: (pharmacyId) => ({
        url: `/api/pharmacies/${pharmacyId}/states`,
        method: "GET",
      }),
      providesTags(_result, _error, arg) {
        return [{ type: TAGS.PHARMACY_STATES, id: arg }];
      },
    }),

    getPharmacyByName: builder.query<Pharmacy, string>({
      query: (name) => ({
        method: "GET",
        url: `/api/pharmacies/${name}`,
      }),
      providesTags(_result, _error, arg) {
        return [{ type: TAGS.PHARMACY, id: arg }];
      },
    }),

    updatePharmacy: builder.mutation<
      Pharmacy,
      { id: number; body: UpdatePharmacy }
    >({
      query: ({ id, body }) => ({
        url: `/api/pharmacies/${id}`,
        method: "PUT",
        body,
      }),

      invalidatesTags: [TAGS.MEDICATIONS],

      onQueryStarted: async (args, { dispatch, queryFulfilled }) => {
        const patch = dispatch(
          pharmacyApi.util.updateQueryData(
            "getPharmacies",
            undefined,
            (draft) => {
              draft.forEach((pharmacy, index, pharmacies) => {
                if (pharmacy.id === args.id) {
                  pharmacies[index] = {
                    ...pharmacy,
                    ...args.body,
                  };
                }
              });
            }
          )
        );

        queryFulfilled.catch(patch.undo);
      },
    }),

    updatePharmacyState: builder.mutation<
      Pharmacy,
      { pharmacyId: number; stateCode: string; body: { active: boolean } }
    >({
      query: ({ pharmacyId, stateCode, body }) => ({
        url: `/api/pharmacies/${pharmacyId}/states/${stateCode}`,
        method: "PUT",
        body,
      }),
      onQueryStarted: async (args, { dispatch, queryFulfilled }) => {
        const patch = dispatch(
          pharmacyApi.util.updateQueryData(
            "getPharmacyStates",
            args.pharmacyId,
            (draft) => {
              draft.forEach((pharmacyState, index, pharmacyStates) => {
                if (pharmacyState.state_code === args.stateCode) {
                  pharmacyStates[index] = {
                    ...pharmacyState,
                    ...args.body,
                  };
                }
              });
            }
          )
        );

        queryFulfilled.catch(patch.undo);
      },
    }),
  }),
});

export const {
  useGetPharmaciesQuery,
  useUpdatePharmacyMutation,
  useGetPharmacyStatesQuery,
  useUpdatePharmacyStateMutation,
  useGetPharmacyByNameQuery,
} = pharmacyApi;
